module.exports = __webpack_public_path__ + "img/normal.b39a2b2d.svg";